import triggerTracking from '@blueprint/tracking/dist/Tracking';

export const trackNewBuildDevelopments = () => {
    triggerTracking({
        event: 'GAEvent',
        eventAction: 'clickthrough',
        eventCategory: 'new_homes',
        eventLabel: 'new_build_developments'
    });
};

export const trackHelpToBuy = () => {
    triggerTracking({
        event: 'GAEvent',
        eventAction: 'clickthrough',
        eventCategory: 'new_homes',
        eventLabel: 'help_to_buy'
    });
};

export const trackSharedOwnership = () => {
    triggerTracking({
        event: 'GAEvent',
        eventAction: 'clickthrough',
        eventCategory: 'new_homes',
        eventLabel: 'shared_ownership'
    });
};

export const trackRetirement = () => {
    triggerTracking({
        event: 'GAEvent',
        eventAction: 'clickthrough',
        eventCategory: 'new_homes',
        eventLabel: 'retirement'
    });
};
